var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('layout-header'),_c('el-container',{staticStyle:{"padding-top":"52px","padding-left":"4px"}},[_c('layout-sider'),_c('el-container',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }